import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { DatePipe, NgClass } from '@angular/common';
import { AppliedOfferListItem, OfferViewModel } from 'src/app/core/models/offer-view.model';
import { OfferDetailViewOrganismComponent } from '../offer-detail-view/offer-detail-view.component';
import { FooterComponent } from '../app-footer/footer.component';

const STATUS_CLASS: Record<string, string> = {
  enproceso: 'state-p',
  preaprobado: 'state-a',
  aprobado: 'state-a',
  rechazado: 'state-r',
  expirado: 'state-r',
  tiempovencido: 'state-r',
};

@Component({
  selector: 'app-applied-offer-card',
  imports: [DatePipe, NgClass, OfferDetailViewOrganismComponent, FooterComponent],
  template: `
    @if (showDetail()) {
    <div class="odv-overlay">
      <div class="odv-overlay__topbar">
        <button class="odv-overlay__back" type="button" (click)="showDetail.set(false)">
          <span class="odv-overlay__back-arrow">&#8249;</span> Regresar
        </button>
      </div>
      <div class="odv-overlay__content">
        <app-offer-detail-view [data]="offer()" (backPressed)="showDetail.set(false)"
          (applyPressed)="showDetail.set(false)" />
      </div>
      <app-footer></app-footer>
    </div>
    } @else {
    <div class="applied-offer-card">
      <div
        class="applied-offer-card__tab"
        [class.applied-offer-card__tab--marquee]="tabTitleIsLong()">
        <div class="applied-offer-card__title-window">
          <h2>{{ tabTitle() }}</h2>
        </div>
      </div>
      <div class="applied-offer-card__body">
        <div class="applied-offer-card__logo">
          <img
            [src]="data().entityimg"
            [alt]="data().companyName"
            [title]="data().productName" />
        </div>
        <div class="applied-offer-card__details">
          <div>
            <span>Ref. de Radicado:</span>
            <strong>{{ data().orderNumber }}</strong>
          </div>
          <div>
            <span>Fecha radicado</span>
            <strong>{{ data().applyDate | date:'dd MMM yyyy' }}</strong>
          </div>
          <div>
            <span>Estado</span>
            <strong [ngClass]="stateClass()">{{ data().status }}</strong>
          </div>
        </div>
      </div>
    </div>
    }
  `,
  styleUrls: [
    '../card-offer/card-offer.component.scss',
    './applied-offer-card.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppliedOfferCardComponent {
  readonly data = input.required<AppliedOfferListItem & Partial<OfferViewModel>>();
  readonly index = input(0);

  readonly showDetail = signal(false);

  readonly tabTitle = computed(() =>
    `${this.data().companyName} - ${this.data().productName}`.trim()
  );
  readonly tabTitleIsLong = computed(() => this.tabTitle().length > 28);

  readonly stateClass = () => {
    const status = this.data().status?.replace(/\s+/g, '').toLowerCase() ?? '';
    return STATUS_CLASS[status] ?? '';
  };

  // El historial (historyAppliedOffer) solo trae datos resumen; si el padre ya
  // enriqueció el item con el catalogo (detail/card/company), se usa tal cual
  // igual que card-offer.component.ts. Si no, se completa con lo minimo disponible.
  readonly offer = computed((): OfferViewModel => {
    const d = this.data();
    if (d.detail && d.card && d.company) {
      return d as OfferViewModel;
    }
    return {
      labelType: '0',
      textLabel: '',
      positionOffer: 0,
      card: { productName: d.productName },
      company: { id: d.companyId, name: d.companyName, entityimg: d.entityimg },
      detail: { companyLogoFlag: false, benefits: [], requirements: [], property: [], score: '0' },
      offerId: Number(d.offerId ?? d.offersId),
      idOffer: String(d.offerId ?? d.offersId ?? ''),
      url: '',
      terms: '',
      timeOffer: '',
      isApplied: true,
      free: false,
      decisorEngine: false,
      urlRedirect: '',
      preselecta: {},
      settings: {} as any,
    };
  });

}

